import {
  Globe, LayoutDashboard, ShoppingCart, Smartphone, Bot, TrendingUp, MapPin,
  Wrench, Megaphone, Sparkles, PenTool, Cloud, Plug, LifeBuoy, Code,
} from "lucide-react";

const map = {
  Globe, LayoutDashboard, ShoppingCart, Smartphone, Bot, TrendingUp, MapPin,
  Wrench, Megaphone, Sparkles, PenTool, Cloud, Plug, LifeBuoy,
};

export function ServiceIcon({ name, className = "h-6 w-6" }) {
  const Icon = map[name] || Code;
  return <Icon className={className} />;
}
